<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="mainSearch.query.whCode" filterable placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.matCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="退料单号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.smCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="mainSearch.query.fcCode">
                    <el-form-item label="料箱箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.boxBarcode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete  EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getStockReturnMatPage">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetClick('mainSearch')">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="!mainSearch.query.fcCode">
                    <el-form-item label="料箱箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.boxBarcode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.query.beginTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="startPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>

            </el-form>
        </box>
        <box fill>
            <plabel text="生产退料（两天以上未完成）">
                <!--<el-button v-authority="'BACK_MENU3_M6_B1'" class="btn-t-edit" @click="closeTask()">
                    关闭
                </el-button>
                <el-button v-authority="'BACK_MENU3_M6_B5'" class="btn-t-edit" @click="receiveReturn()">
                    退料接收
                </el-button>-->
                <!-- <el-button v-authority="'BACK_MENU3_M6_B2'" class="btn-t-edit" @click="handCompleted()">
                    搬运完成
                </el-button> -->
              <!--<el-button v-authority="'BACK_MENU3_M6_B3'" class="btn-t-edit" @click="rejectStock()">
                退料驳回
            </el-button>-->
                <el-button v-authority="'BACK_MENU3_M6_B4'" class="btn-t-edit" :loading="downloadLoading" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="mainSearch.headerCellStyle" style="flex: 1" @pageChange="getStockReturnMatPage" :data="mainSearch.data" pagination :nowPage.sync="mainSearch.pageNum" :pageSize.sync="mainSearch.pageSize" :total.sync="mainSearch.total" @selectionChange="selectMain">
                <el-table-column type="selection" align="center" :selectable="checkboxSelect">
                </el-table-column>
                <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="退料单号" align="center" prop="smCode">
                </el-table-column>
                <el-table-column label="退料状态" align="center" prop="spStatus">
                    <template slot-scope="scope">
                        <span v-if="scope.row.spStatus == 'CREATE'">创建</span>
                        <span v-if="scope.row.spStatus == 'WAIT'">待上架</span>
                        <span v-if="scope.row.spStatus == 'REJECT'">驳回</span>
                        <span v-if="scope.row.spStatus == 'RECEiIVE'">驳回已接收</span>
                        <span v-if="scope.row.spStatus == 'RETURN'">退料已接收</span>
                        <span v-if="scope.row.spStatus == 'UPPERING'">上架中</span>
                        <span v-if="scope.row.spStatus == 'CONFIRM'">完成</span>
                        <span v-if="scope.row.spStatus == 'CLOSE'">关闭</span>
                    </template>
                </el-table-column>
                <el-table-column label="退料数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="退料方式" align="center" prop="distrType">
                    <template slot-scope="scope">
                        <span v-if="scope.row.distrType == '20'">人工退料</span>
                        <span v-if="scope.row.distrType == '10'">AGV退料</span>
                    </template>
                </el-table-column>
                <el-table-column label="位置" align="center" prop="taskFinishPoint">
                </el-table-column>
                <el-table-column label="退料原因" align="center" prop="wtName">
                </el-table-column>
                <el-table-column label="操作人员" align="center" prop="person">
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime">
                </el-table-column>
                <el-table-column label="修改时间" align="center" prop="updateTime">
                </el-table-column>
                <el-table-column label="操作" min-width="100">
                    <template slot-scope="scope">
                        <div class="tabke-el">
                            <el-button class="btn-t-edit" @click="detailDialog(scope.row.smCode)" v-authority="'BACK_MENU3_M6_B6'" >明细</el-button>

                        </div>
                    </template>
                    
                </el-table-column>
            </h-table>
        </box>
        <!-- 生产退料明细 -->
        <el-dialog title="生产退料明细" :visible.sync="detailData.insertShowRecord" class="fromDialog"  :style="$popups.popups(0.8,0.9)"  :close-on-click-modal="false" :show-close="false">
            <h-table :headerCellStyle="detailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.8)" @pageChange="getStockReturnMatList()" :data="detailData.data" pagination :nowPage.sync="detailData.pageNum" :pageSize.sync="detailData.pageSize" :total.sync="detailData.total">
                <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="退料数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="批次号" align="center" prop="batchNo">
                </el-table-column>
                <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                </el-table-column>
                <el-table-column label="退料单号" align="center" prop="smCode">
                </el-table-column>
                <el-table-column label="退料状态" align="center" prop="spStatus">
                    <template slot-scope="scope">
                        <span v-if="scope.row.spStatus == 'CREATE'">创建</span>
                        <span v-if="scope.row.spStatus == 'WAIT'">待上架</span>
                        <span v-if="scope.row.spStatus == 'REJECT'">驳回</span>
                        <span v-if="scope.row.spStatus == 'RECEiIVE'">驳回已接收</span>
                        <span v-if="scope.row.spStatus == 'RETURN'">退料已接收</span>
                        <span v-if="scope.row.spStatus == 'UPPERING'">上架中</span>
                        <span v-if="scope.row.spStatus == 'CONFIRM'">完成</span>
                        <span v-if="scope.row.spStatus == 'CLOSE'">关闭</span>
                    </template>
                </el-table-column>
                <el-table-column label="位置" align="center" prop="laCodeReturn">
                </el-table-column>
                <el-table-column label="备注" align="center" prop="remark">
                </el-table-column>
                <el-table-column label="半成品" align="center" prop="halfProductFlag">
                  <template slot-scope="scope">
                    <span v-if="scope.row.halfProductFlag">是</span>
                    <span v-if="!scope.row.halfProductFlag">否</span>
                  </template>
                </el-table-column>
                <el-table-column label="组件" align="center" prop="assemblyFlag">
                  <template slot-scope="scope">
                    <span v-if="scope.row.assemblyFlag">是</span>
                    <span v-if="!scope.row.assemblyFlag">否</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作人员" align="center" prop="person">
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime">
                </el-table-column>
                <el-table-column label="修改时间" align="center" prop="updateTime">
                </el-table-column>

              <el-table-column label="操作" min-width="100">
                <template slot-scope="scope">
                  <div class="tabke-el">

                    <el-button v-if="scope.row.spStatus =='CREATE' && scope.row.distrType =='20'" class="btn-t-edit" @click="closeTaskDetail(scope.row)" >
                      关闭
                    </el-button>
                  </div>
                </template>

              </el-table-column>
            </h-table>
          <br><br>
          <v-print :doPrint.sync="print">
            <h-table v-if="" width="100%" height="100%" id="demo" :headerCellStyle="detailData.headerCellStyle" :style="$popups.harvestRecordStyle(1)" @pageChange="getStockReturnMatList()" :data="detailData.data"  :total.sync="detailData.total">
              <el-table-column label="通道编号" align="center" prop="whCode">
              </el-table-column>
              <el-table-column label="物料编号" align="center" prop="matCode">
              </el-table-column>
              <el-table-column label="物料描述" align="center" prop="matName">
              </el-table-column>
              <el-table-column label="退料数量" align="center" prop="matQuan">
              </el-table-column>
              <el-table-column label="批次号" align="center" prop="batchNo">
              </el-table-column>
              <el-table-column label="包装箱号" align="center" prop="boxBarcode">
              </el-table-column>
              <el-table-column label="退料单号" align="center" prop="smCode">
              </el-table-column>
              <el-table-column label="退料状态" align="center" prop="spStatus">
                <template slot-scope="scope">
                  <span v-if="scope.row.spStatus == 'CREATE'">创建</span>
                  <span v-if="scope.row.spStatus == 'WAIT'">待上架</span>
                  <span v-if="scope.row.spStatus == 'REJECT'">驳回</span>
                  <span v-if="scope.row.spStatus == 'RECEiIVE'">驳回已接收</span>
                  <span v-if="scope.row.spStatus == 'RETURN'">退料已接收</span>
                  <span v-if="scope.row.spStatus == 'UPPERING'">上架中</span>
                  <span v-if="scope.row.spStatus == 'CONFIRM'">完成</span>
                  <span v-if="scope.row.spStatus == 'CLOSE'">关闭</span>
                </template>
              </el-table-column>
              <el-table-column label="位置" align="center" prop="laCodeReturn">
              </el-table-column>
              <el-table-column label="备注" align="center" prop="remark">
              </el-table-column>
              <el-table-column label="操作人员" align="center" prop="person">
              </el-table-column>
              <el-table-column label="创建时间" align="center" prop="createTime">
              </el-table-column>
              <el-table-column label="修改时间" align="center" prop="updateTime">
              </el-table-column>
            </h-table>
          </v-print>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="detailData.insertShowRecord = false" type="info" class="btn-t-info">关 闭</el-button>
                <el-button class="btn-t-edit" @click="printShow">打印</el-button>
            </div>
        </el-dialog>

        <!-- 确认上架弹出框 -->
        <el-dialog title="上架库位选择" :visible.sync="shelfDate.insertShowRecord" class="fromDialog" :style="$popups.popups(0.8,0.9)"  :close-on-click-modal="false" :show-close="false">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="80px">
                     <el-col :lg="5" :xl="5">
                        <el-form-item label="上架库位" class="EL-Form-Item">
                            <el-select v-model="shelfDate.groundingLaCode" placeholder="请选择"  clearable="clearable" filterable remote :remote-method="remoteMethodLcCode" @change="changeTranLcCode()">
                                <el-option v-for="item in lcCodeList" :key="item.lcId" :label="item.lcCode" :value="item.lcCode">{{item.lcCode}}</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div>
                <h-table :headerCellStyle="shelfDate.headerCellStyle" :style="$popups.harvestRecordStyle(0.69)" @pageChange="getStockReturnMatList" :data="shelfDate.data" pagination :nowPage.sync="shelfDate.pageNum" :pageSize.sync="shelfDate.pageSize" :total.sync="shelfDate.total" :key="rowTableKey" @selectionChange="selectupper">
                    <el-table-column type="selection" align="center">
                    </el-table-column>
                    <el-table-column label="通道编号" align="center" prop="whCode">
                    </el-table-column>
                    <el-table-column label="物料编号" align="center" prop="matCode">
                    </el-table-column>
                    <el-table-column label="物料描述" align="center" prop="matName">
                    </el-table-column>
                    <el-table-column label="退料数量" align="center" prop="matQuan">
                    </el-table-column>
                    <el-table-column label="批次号" align="center" prop="batchNo">
                    </el-table-column>
                    <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                    </el-table-column>
                    <el-table-column label="退料库位" prop="traferCode" align="center" width="150">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.traferCode" placeholder="请选择" :clearable="true" filterable remote :remote-method="remoteMethodLcCode" @change="handleChange()">
                            <el-option v-for="(item) in lcCodeList" :key="item.lcId" :label="item.lcCode" :value="item.lcCode">
                            </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="退料单号" align="center" prop="smCode">
                    </el-table-column>
                    <el-table-column label="退料状态" align="center" prop="spStatus">
                        <template slot-scope="scope">
                            <span v-if="scope.row.spStatus == 'CREATE'">创建</span>
                            <span v-if="scope.row.spStatus == 'WAIT'">待上架</span>
                            <span v-if="scope.row.spStatus == 'REJECT'">驳回</span>
                            <span v-if="scope.row.spStatus == 'RECEiIVE'">驳回已接收</span>
                            <span v-if="scope.row.spStatus == 'RETURN'">退料已接收</span>
                            <span v-if="scope.row.spStatus == 'UPPERING'">上架中</span>
                            <span v-if="scope.row.spStatus == 'CONFIRM'">完成</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注" align="center" prop="remark">
                    </el-table-column>
                  <el-table-column label="半成品" align="center" prop="halfProductFlag">
                    <template slot-scope="scope">
                      <span v-if="scope.row.halfProductFlag">是</span>
                      <span v-if="!scope.row.halfProductFlag">否</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="组件" align="center" prop="assemblyFlag">
                    <template slot-scope="scope">
                      <span v-if="scope.row.assemblyFlag">是</span>
                      <span v-if="!scope.row.assemblyFlag">否</span>
                    </template>
                  </el-table-column>
                    <el-table-column label="操作人员" align="center" prop="person">
                    </el-table-column>
                    <el-table-column label="创建时间" align="center" prop="createTime">
                    </el-table-column>
                    <el-table-column label="修改时间" align="center" prop="updateTime">
                    </el-table-column>
                </h-table>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="shelfDate.insertShowRecord = false" type="info" class="btn-t-info">关 闭</el-button>
                <el-button @click="upperStockReturnMat()" class="btn-t-edit">确 认</el-button>
            </div>
        </el-dialog>

        <!--驳回-->
        <el-dialog title="驳回完成选择" :visible.sync="reject.insertShowRecord" class="fromDialog" :style="$popups.popups(0.2,0.3)" :close-on-click-modal="false" :show-close="false">
            <el-form label-position="right" label-width="70px">
                <el-form-item label="驳回方式" prop="rejectType" class="EL-Form-Item">
                    <el-select v-model="reject.rejectType" placeholder="请选择" :disabled="reject.isAble">
                        <el-option label="人工驳回" value="20" />
                        <el-option label="AGV驳回" value="10" />
                    </el-select>
                </el-form-item>
                <el-form-item label="驳回原因" prop="remark" class="EL-Form-Item">
                    <el-input v-model="reject.reasonsRejection" placeholder="请输入"></el-input>
                </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="reject.insertShowRecord = false" type="info" class="btn-t-info">关 闭</el-button>
                <el-button @click="rejectStockReturnMat()" class="btn-t-edit">确 认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import htmlToPdf from "@/libs/htmlToPdf";
import vPrint from "syl-vue-printer";

export default {
  name: "TransferWriteXA",
  components: {
    vPrint,
  },
    data(){
        return {
            // 首页的数据和查询
            mainSearch: {
                query:{
                    person: localStorage.getItem("user") || "",
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: "", // localStorage.getItem("whCode") ||
                    smCode: "",
                    matCode: "",
                    boxBarcode: "",
                    status: "CREATE,WAIT",
                    beginTime: "",
                    endTime: "",
                },
                data: [],
                pageNum: 1,
                pageSize: 50,
                total: 0,
                insertShowRecord: false,
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },
            },
            print:false,
            // 明细
            detailData: {
                smCode: "",
                data: [],
                pageNum: 1,
                pageSize: 50,
                total: 0,
                insertShowRecord: false,
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },
            },
            // 上架的库位
            shelfDate:{
                // 选择上架的库位
                groundingLaCode: "",
                smCode: "",
                data: [],
                pageNum: 1,
                pageSize: 50,
                total: 0,
                insertShowRecord: false,
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },
            },
            // 驳回的数据和退料选择
            reject:{
                isAble: false,
                rejectType: "",
                reasonsRejection:"", //驳回原因
                data: [],
                pageNum: 1,
                pageSize: 50,
                total: 0,
                insertShowRecord: false,
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },
            },
            // 首页的多选
            checkListMain: [],
            // 选择上架数据
            selectupperList: [],
            // 库位选择
            laCodeList: [],
            // 通道集合
            warehouseList: [],
            // 完成后保存日志的内容
            logRemarks: "",
            //下载中
            downloadLoading: false,
            // 输入框延时加载
            isSetTimeout: null,
            lcCodeList: [],
            lcCodeLoading: false,
            rowLcCodeList: [],
            rowTableKey: false,
        }
    },
    watch:{
        "mainSearch.query":{
            handler() {
                clearTimeout(this.isSetTimeout);
                this.isSetTimeout = setTimeout(() => {
                    this.getStockReturnMatPage();
                }, 1000);
            },
            deep: true,
        }
    },
    computed:{
         startPickerOptions() {
            let _this = this;
            return {
                disabledDate(time) {
                    if (_this.mainSearch.query.beginTime) {
                        return time.getTime() > new Date(_this.mainSearch.query.beginTime);
                    }
                },
            };
        },
        finishPickerOptions() {
            let _this = this;
            return {
                disabledDate(time) {
                    if (_this.mainSearch.query.endTime) {
                        return time.getTime() < new Date(_this.mainSearch.query.endTime);
                    }
                },
            };
        },
    },
    methods:{
        //禁选
        checkboxSelect(row, rowIndex) {
            if (row.spStatus == "CREATE" || row.spStatus == "WAIT") {
                return true; // 不禁用
            } else {
                return false; // 禁用
            }
        },
         /* 上架多选 */
        selectupper(val){
            this.selectupperList = val;
        },
        /* 多选 */
        selectMain(val) {
            this.checkListMain = val;
        },
        printShow(){

          document.querySelector("#demo").style.display = "";
          this.print = true;

        },
        /* 远程搜索库位号 */
        remoteMethodLcCode(query) {
            if (query || query == 0) {
                this.lcCodeLoading = true;
                this.getSysLocationAll(query);
                setTimeout(() => {
                this.lcCodeLoading = false;
                if (this.lcCodeList != undefined) {
                    this.lcCodeList = this.lcCodeList.filter((item) => {
                        return (item.lcCode.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    });
                    this.rowLcCodeList=this.lcCodeList;
                }
                }, 200);
            } else {
                this.lcCodeList = [];
                this.rowLcCodeList = [];
            }
        },
      handleDown() {
        // console.log(document.querySelector("#demo"));
        htmlToPdf.downloadPDF(document.querySelector("#demo"), "X-R控制图");
      },
        //统一上架库位
        changeTranLcCode(){
            if(this.shelfDate.groundingLaCode !=''){
                this.shelfDate.data.forEach((item)=>{
                    item['traferCode'] = this.shelfDate.groundingLaCode;
                })
                this.rowTableKey = !this.rowTableKey;
            }
        },
        handleChange(){
            this.$forceUpdate();
            this.rowTableKey = !this.rowTableKey;
        },
        /* 获取所有的库位 */
        getSysLocationAll(lcCode) {
            this.$http
                .request({
                url: "/api/location/getLaCodeAllByType",
                method: "GET",
                params: {
                    lcType: "AD,FLOOR,GL",
                    fcCode: localStorage.getItem("fcCode") || "",
                    lcCode: lcCode || "",
                },
                })
                .then((resp) => {
                if (resp.status == 100) {
                    if (resp.data && resp.data.list) {
                        this.lcCodeList = resp.data.list;
                        this.rowLcCodeList = resp.data.list;
                    }else{
                        this.lcCodeList = [];
                        this.rowLcCodeList =[];
                    }
                }
                })
                .catch((error) => {
                this.$message({
                    message: "操作失败",
                    type: "warning",
                });
            });
        },
        /* 确认上架 */
        upperStockReturnMat() {  
            var lcCodeFlag = false;
            var lcCodeWhcodeFlag = false;
            this.selectupperList.forEach((item) => {
                if(item.lcCode == item.traferCode){
                    lcCodeFlag = true;
                }
                if(item.traferCode == ""){
                    lcCodeWhcodeFlag = true;  
                }   
            }) 
            if(this.selectupperList.length == 0){
                this.$message({
                    message: "没有选择内容",
                    type: "warning",
                });
                return;
            }
            // if(this.shelfDate.groundingLaCode == ''){
            //         this.$message({
            //         message: "请选择上架库位",
            //         type: "warning",
            //     });
            //     return;
            // }else 
            if (lcCodeWhcodeFlag) {
                this.$message({
                    message: "请选择移入库位！",
                    type: "warning",
                });
                return;
            } else if (lcCodeFlag && this.shiftOutSeat.traferWhCode == '') {
                this.$message({
                    message: "移入的库位不能和原库位相同！",
                    type: "warning",
                });
                return;
            }else{
                this.$confirm("是否退料重新上架?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        var boxBarcodeList = this.selectupperList.map((element) => {
                            return element.boxBarcode;
                        });
                        var laCodeList = this.selectupperList.map((element) => {
                            return element.traferCode;
                        });
                        this.$http
                            .request({
                                url: "/api/stockReturnMat/upperStockReturnMatList",
                                method: "PUT",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || null,
                                    personNumber: localStorage.getItem("empNumber") || null,
                                    smCodes: this.detailData.smCode,
                                },
                                data: this.selectupperList
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "stockReturnMat：退料重新上架成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "stockReturnMat：退料重新上架失败";
                                }
                                // this.systemLog();
                                this.shelfDate.insertShowRecord = false;
                                this.shelfDate.groundingLaCode = '';
                                //刷新数据
                                this.getStockReturnMatPage();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            }
            
        },

        /**
         * 搬运完成 （人工 创建状态的才能点击)
         */
        handCompleted(){
            if (this.checkListMain.length == 0) {
                this.$message({
                    message: "没有选择内容",
                    type: "warning",
                });
                return;
            }
            var res = this.checkListMain.every(e => {
                if (e.distrType != '20') {
                    this.$message({
                        message: "只能选择为人工搬运的任务！",
                        type: "warning",
                    });
                    return false;
                }else if (e.spStatus != 'CREATE') {
                        this.$message({
                            message: "只能选择创建状态的任务！",
                            type: "warning",
                        });
                        return false;
                    } else {
                    return true;
                }
            })
            if (res == false) {
                return false;
            }
            var smCodes = this.checkListMain.map((e)=>{
                if (e.smCode) {
                    return e.smCode;
                }
            })

            this.$confirm("是否确认搬运完成?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    this.$http
                        .request({
                            url: "/api/stockReturnMat/insertHandCompleted",
                            method: "POST",
                            showLoading: true,
                            params: {
                                    smCodes: smCodes.join(","),
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    message: resp.message,
                                    type: "error",
                                });
                            }
                            //刷新数据
                            this.getStockReturnMatPage();
                        })
                        .catch((error) => {
                            this.$message({
                                message: "操作失败",
                                type: "warning",
                            });
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消退料",
                    });
                });
        },

      closeTaskDetail(item){
        this.$http
            .request({
              url: "/api/pda/StockReturnCloseBoxBarCode",
              method: "PUT",
              showLoading: true,
              params: {
                person: localStorage.getItem("user") || "",
                personNumber: localStorage.getItem("empNumber") || null,
              },
              data: item,
            })
            .then((res) => {
              if (res.status == 100) {
                this.$message({
                  message: "关闭成功",
                  type: "success",
                });
                this.getStockReturnMatList();
                //刷新数据
                this.getStockReturnMatPage();
              } else if (res.status == 500) {
                this.$message({
                  message: "关闭失败",
                  type: "warning",
                });
              } else {
                this.$message({
                  message: res.message,
                  type: "warning",
                });
              }
            });
      },
        /* 关闭任务-只能关闭创建状态的 */
        closeTask(smCode){
            var smCodes = "";
            if(smCode != undefined && smCode != ''){
              smCodes = [smCode];

            }else{
              if (this.checkListMain.length == 0) {
                this.$message({
                  message: "没有选择内容",
                  type: "warning",
                });
                return;
              }
              var every = this.checkListMain.every(e => {
                if (e.spStatus != 'CREATE' && e.spStatus != 'WAIT') {
                  this.$message({
                    message: "只能选择创建/待上架状态的任务！",
                    type: "warning",
                  });
                  return;
                }
              })
              if (every) {
                return;
              }
              smCodes = this.checkListMain.map((e)=>{
                if (e.smCode) {
                  return e.smCode;
                }
              })
            }

            this.$confirm("是否确认关闭?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    this.$http
                        .request({
                            url: "/api/stockReturnMat/closeTask",
                            method: "POST",
                            showLoading: true,
                            params :{
                                smCodes: smCodes.join(","),
                                person: localStorage.getItem("user") || "",
                                personNumber: localStorage.getItem("empNumber") || null,
                            }
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    message: resp.message,
                                    type: "error",
                                });
                            }
                            //刷新数据
                            this.getStockReturnMatPage();
                        })
                        .catch((error) => {
                            this.$message({
                                message: "操作失败",
                                type: "warning",
                            });
                        });
                })
                .catch((error) => {
                    this.$message({
                        type: "info",
                        message: "已取消退料",
                    });
                });
        },
        /* 退料驳回弹框 */
        rejectStock(){
            if (this.checkListMain.length == 0) {
                this.$message({
                    message: "没有选择内容",
                    type: "warning",
                });
                return;
            }else if (this.checkListMain.length != 1&& false) {
                this.$message({
                    message: "只能对一个退料单进行退料驳回操作！",
                    type: "warning",
                });
                return;
            }else if (this.checkListMain.spStatus != 'CREATE') {
              var spStatusReturn = false;
              this.checkListMain.forEach(e=>{
                if (e.spStatus != 'CREATE') {
                  this.$message({
                    message: "只能选择创建状态的退料任务！",
                    type: "warning",
                  });
                  spStatusReturn = true;
                }

              })
              if(spStatusReturn){
                return;
              }


            }
            this.checkListMain.forEach(e=>{
                if (e.distrType == '20') {
                    this.reject.rejectType = '20'
                    this.reject.isAble = true;
                }
            })
            this.reject.insertShowRecord = true;
        },

        /* 退料驳回 */
        rejectStockReturnMat() {
            if (this.reject.rejectType == "") {
                this.$message({
                    message: "请选择驳回方式",
                    type: "warning",
                });
                return;
            }
            var smCodes = this.checkListMain.map((ele) => {
                return ele.smCode
            });
            this.$http
                .request({
                    url: "/api/stockReturnMat/rejectStockReturnMat",
                    method: "PUT",
                    showLoading: true,
                    params: {
                        smCodes: smCodes.join(","),
                        rejectType:this.reject.rejectType,
                        reasonsRejection:this.reject.reasonsRejection,
                        person: localStorage.getItem("user") || "",
                        personNumber: localStorage.getItem("empNumber") || "",
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                        this.logRemarks = "stockReturnMat：驳回退料成功";
                    } else {
                        this.$message({
                            message: resp.message,
                            type: "error",
                        });
                        this.logRemarks = "stockReturnMat：驳回退料失败";
                    }
                    this.systemLog();
                    this.reject.insertShowRecord = false;
                    this.reject.rejectType = "";
                    //刷新数据
                    this.getStockReturnMatPage();
                })
                .catch((error) => {
                    this.$message({
                        message: "操作失败",
                        type: "warning",
                    });
                });
        },
        /* 明细 */
        detailDialog(smCode) {
            this.detailData.insertShowRecord = true;
            this.detailData.smCode = smCode;
            this.getStockReturnMatList();
        },
        /* 确认上架 */
        shelfLocation(smCode){
            this.shelfDate.insertShowRecord = true;
            this.detailData.smCode = smCode;
            this.getStockReturnMatList("CREATE,WAIT,UPPERING,REJECT");
            this.getlaCode();
            this.getSysLocationAll();
        },
        /* 获取AD库位 */
        getlaCode() {
            this.$http
                .request({
                    url: "/api/location/getLocationAll",
                    method: "GET",
                    params: {
                        //lcType: "AD,FLOOR",
                        fcCode: localStorage.getItem("fcCode") || "",
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.laCodeList = resp.data.list || [];
                    }
                })
        },
        /* 获取生产退料信息-退料单明细 */
        getStockReturnMatList(status) {
            this.$http
                .request({
                    url: "/api/stockReturnMat/getStockReturnMatList",
                    method: "GET",
                    params: {
                        pageNum: this.detailData.nowPage,
                        pageSize: this.detailData.pageSize,
                        smCode: this.detailData.smCode,
                        status: status || "",
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.shelfDate.data = resp.data.list || [];
                        this.shelfDate.total = resp.data.total;
                        this.detailData.data = resp.data.list || [];
                        this.detailData.total = resp.data.total;
                    }
                })
                .catch((error) => {
                    this.$message({
                        message: "操作失败",
                        type: "warning",
                    });
                });
        },
        /* 所有重置的点击事件 */
        resetClick(type) {
            if (type == "mainSearch") {
                this.mainSearch.query = {
                fcCode: localStorage.getItem("fcCode") || "",
                lcCode: "",
                whCode: "",
                matCode: "",
                matName: "",
                batchNo: "",
                boxBarcode: "",
                orderCode: "",
                status: "CREATE,WAIT",
                date: [],
                };
                this.mainSearch.pageNum = 1;
                this.getStockReturnMatPage();
            }
        },
        /* 获取通道数据 */
        getWarehouse() {
            this.$http
                .request({
                    url: "/api/warehouse/getWarehouse",
                    method: "GET",
                    params: {
                        fcCode: localStorage.getItem("fcCode") || "",
                        whCode: "",
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.warehouseList = resp.data.list || [];
                    }
                })
        },
        /* 获取生产退料信息-退料单 */
        getStockReturnMatPage() {
            clearTimeout(this.isSetTimeout);
            this.$http
                .request({
                    url: "/api/stockReturnMat/getStockReturnMatPage",
                    method: "GET",
                    params: {
                        fcCode: this.mainSearch.query.fcCode || null,
                        whCode: this.mainSearch.query.whCode || null,
                        smCode: this.mainSearch.query.smCode || null,
                        matCode: this.mainSearch.query.matCode || null,
                        boxBarcode: this.mainSearch.query.boxBarcode || null,
                        status: this.mainSearch.query.status || null,
                        beginTime: this.mainSearch.beginTime || null,
                        endTime: new Date(new Date().getTime() - 1000 * 60 * 60 * 48),
                        pageNum: this.mainSearch.pageNum,
                        pageSize: this.mainSearch.pageSize,
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.mainSearch.data = resp.data.list || [];
                        this.mainSearch.total = resp.data.total || 0;
                    }
                })
                .catch((error) => {
                    this.$message({
                        message: "操作失败",
                        type: "warning",
                    });
                });
        },
        /**
         * 退料接收
         */
        receiveReturn() {
            if (this.checkListMain.length == 0) {
                this.$message({
                    message: "没有选择退料内容",
                    type: "warning",
                });
                return;
            }
            var every = this.checkListMain.every(e => {
                if (e.spStatus != 'CREATE') {
                    this.$message({
                        message: "只能选择创建状态的退料任务！",
                        type: "warning",
                    });
                    return true;
                }
            })
            if (every) {
                return;
            }
            var smCodes = this.checkListMain.map((e)=>{
                if (e.smCode) {
                    return e.smCode;
                }
            })
            this.$confirm("是否确认接收已选退料内容?", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .request({
                            url: "/api/stockReturnMat/receiveReturn",
                            method: "POST",
                            showLoading: true,
                            params :{
                                smCodes: smCodes.join(","),
                                person: localStorage.getItem("user") || "",
                                personNumber: localStorage.getItem("empNumber") || null,
                            }
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    message: resp.message,
                                    type: "error",
                                });
                            }
                            //刷新数据
                            this.getStockReturnMatPage();
                        })
                        .catch((error) => {
                            this.$message({
                                message: "操作失败",
                                type: "warning",
                            });
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消退料",
                    });
                });
        },
        //表格导出
        downLoadFile() {
            this.downloadLoading = true;
            var paramsObj = {
                fcCode: this.mainSearch.query.fcCode || null,
                whCode: this.mainSearch.query.whCode || null,
                smCode: this.mainSearch.query.smCode || null,
                matCode: this.mainSearch.query.matCode || null,
                boxBarcode: this.mainSearch.query.boxBarcode || null,
                status: this.mainSearch.query.status || null,
                beginTime: this.mainSearch.beginTime || null,
                endTime: new Date(new Date().getTime() - 1000 * 60 * 60 * 48),
                pageNum: 1,
                pageSize: 999999,

            }
            this.$http.request({
                url: '/api/stockReturnMat/getStockReturnMatPage',
                method: 'GET',
                params: paramsObj
            }).then((resp) => {
                resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                    message: '查询失败'
                });
            })
        },
        downLoad(list) {
            import('@/libs/Export2Excel').then(excel => {
                list.forEach(function(c) {
                    if (c.spStatus == 'CREATE') {
                        c['spStatus'] = '创建'
                    } else if (c.spStatus == 'WAIT') {
                        c['spStatus'] = '待上架'
                    }else if (c.spStatus == 'REJECT') {
                        c['spStatus'] = '驳回'
                    } else if (c.spStatus == 'RECEiIVE') {
                        c['spStatus'] = '驳回已接收'
                    } else if (c.spStatus == 'RETURN') {
                        c['spStatus'] = '退料已接收'
                    } else if (c.spStatus == 'UPPERING') {
                        c['spStatus'] = '上架中'
                    } else if (c.spStatus == 'CONFIRM') {
                        c['spStatus'] = '完成'
                    }

                    if(c.distrType == '20'){
                            c['distrType'] = '人工退料'
                    }else if(c.distrType=='10'){
                            c['distrType'] = 'AGV退料'
                    }
                })
                const tHeader = ['通道编号', '退料单号', '退料状态', '退料数量','退料方式','位置','退料原因', '操作人员', '创建时间', '修改时间']
                const filterVal = ['whCode', 'smCode', 'spStatus', 'matQuan','distrType','taskFinishPoint', 'wtName','person', 'createTime', 'updateTime']
                const data = this.formatJson(filterVal, list)
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: '退料确认'
                })
                this.logRemarks = "stock_return_mat：导出退料确认记录"
                this.systemLog();
                this.downloadLoading = false
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },
        /* 操作日志 */
        systemLog() {
            let objData = {
                logType: "退料确认",
                logContent: this.logRemarks || "",
                //logRemarks: this.logRemarks || "",
                logUser: localStorage.getItem("user") || "",
            };
            this.$http
                .request({
                    url: "api/log/insert",
                    method: "POST",
                    showLoading: true,
                    data: objData,
                })
                .then((resp) => {
                    this.logRemarks = "";
                    if (resp.status == 100) {}
                })
                .catch((error) => {});
        },
    },
    activated(){
        /* 获取通道数据 */
        this.getWarehouse();
        /* 获取生产退料信息-退料单 */
        this.getStockReturnMatPage();
    },
}
</script>
<style lang="scss" scoped>
.tabke-el{
    display: flex;
}

</style>